import script from "./taskDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./taskDetail.vue?vue&type=script&setup=true&lang=js"

import "./taskDetail.vue?vue&type=style&index=0&id=3dba427f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dba427f"]])

export default __exports__